import styled from "styled-components";

export const TabContentContainer = styled.div`
  padding-top: 12px;
`;
